export default __webpack_public_path__ + "static-bigflip/media/logo-flowflip.d2b5a7b2.png";